export const locationsApi = (client) => ({
    list: (siteId, params) => client.get(`/api/v1/sites/${siteId}/locations`, { params }).then((r) => r.data),
    tree: (siteId) => client.get(`/api/v1/sites/${siteId}/locations/tree`).then((r) => r.data),
    get: (siteId, id) => client.get(`/api/v1/sites/${siteId}/locations/${id}`).then((r) => r.data),
    create: (siteId, body) => client.post(`/api/v1/sites/${siteId}/locations`, body).then((r) => r.data),
    update: (siteId, id, body) => client.patch(`/api/v1/sites/${siteId}/locations/${id}`, body).then((r) => r.data),
    remove: (siteId, id) => client.delete(`/api/v1/sites/${siteId}/locations/${id}`).then((r) => r.data),
    /// Soft-delete up to 200 root locations plus every descendant under
    /// each. The single-row delete blocks parents-with-children; this
    /// path explicitly cascades because it's for "wipe a bad import".
    bulkRemove: (siteId, ids) => client.post(`/api/v1/sites/${siteId}/locations/bulk-delete`, { ids }).then((r) => r.data),
    search: (q) => client.get('/api/v1/locations/search', { params: { q } }).then((r) => r.data),
    listChecklists: (locationId) => client.get(`/api/v1/locations/${locationId}/checklists`).then((r) => r.data),
    addChecklist: (locationId, template_id) => client.post(`/api/v1/locations/${locationId}/checklists`, { template_id }).then((r) => r.data),
    removeChecklist: (locationId, templateId) => client.delete(`/api/v1/locations/${locationId}/checklists/${templateId}`).then((r) => r.data),
    // Attachments
    listAttachments: (id) => client.get(`/api/v1/locations/${id}/attachments`).then((r) => r.data),
    uploadAttachment: (id, file, onProgress) => {
        const form = new FormData();
        form.append('file', file);
        return client.post(`/api/v1/locations/${id}/attachments`, form, {
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress: (e) => { if (onProgress && e.total)
                onProgress(Math.round((e.loaded / e.total) * 100)); },
        }).then((r) => r.data);
    },
    viewAttachment: (id, fileId) => client.get(`/api/v1/locations/${id}/attachments/${fileId}/view`, { responseType: 'blob' }).then((r) => r),
    deleteAttachment: (id, fileId) => client.delete(`/api/v1/locations/${id}/attachments/${fileId}`).then((r) => r.data),
});
//# sourceMappingURL=locations.js.map